import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import {resetPassword, resetPasswordFailure} from "../../store/main/action";

// ---------------------------------------------------------------------------
// Страница из письма: token и email приходят в адресе, пользователь задаёт
// новый пароль. После смены сервер отзывает все токены — входить нужно заново,
// поэтому ведём на страницу входа
// ---------------------------------------------------------------------------

const ResetMain = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const started = useSelector(store => store.main.resetPasswordStarted);
    const err = useSelector(store => store.main.resetPasswordErr);

    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';

    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [isDone, setIsDone] = useState(false);

    const hasLink = !!token && !!email;

    const sendFormHandler = useCallback(()=>{
        if (started || !hasLink || !password.length || !confirmation.length){
            return;
        }

        dispatch(resetPassword({
            token,
            email,
            password,
            password_confirmation: confirmation
        }, ()=>{
            setIsDone(true);
        }));
    }, [started, hasLink, token, email, password, confirmation, dispatch])

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                sendFormHandler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);

    const errors = err?.errors;
    const passwordErr = errors?.password?.[0];
    const confirmationErr = errors?.password_confirmation?.[0];
    // протухшую или уже использованную ссылку сервер помечает errors.token
    const tokenErr = errors?.token?.[0] || errors?.email?.[0];
    const commonErr = !errors && (err?.message || '');

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.formWrap}`}>
                    <div className={`${Styles.formTitle}`}>{t('Новый пароль')}</div>

                    {isDone ? (
                        <>
                            <div className={`${Styles.doneWrap}`}>
                                <span className={`${Styles.doneMark}`}>✓</span>
                                <span className={`${Styles.doneTitle}`}>{t('Пароль изменён')}</span>
                            </div>

                            <div className={`${Styles.formNote}`}>
                                {t('Войдите с новым паролем. На других устройствах сеансы завершены.')}
                            </div>

                            <div className={`${Styles.tcBtn}`} onClick={()=>{navigate('/sign-in')}}>{t('Вход')}</div>
                        </>
                    ) : !hasLink ? (
                        <>
                            <div className={`${Styles.formNote}`}>
                                {t('Ссылка неполная — откройте её из письма целиком или запросите новую.')}
                            </div>
                            <div className={`${Styles.tcBtn}`} onClick={()=>{navigate('/forgot-password')}}>
                                {t('Запросить ссылку')}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className={`${Styles.formNote}`}>
                                {t('Задайте новый пароль для')} {email}
                            </div>

                            <div className={`${Styles.contentBox}`}>
                                <div className={`${Styles.inputWrap} ${passwordErr ? Styles.inputWrapWithErr : null}`}>
                                    <div className={`${Styles.inputTitle}`}>{t('Новый пароль')}</div>
                                    <input
                                        className={`${Styles.tcInput}`}
                                        type="password"
                                        placeholder="••••••••"
                                        value={password}
                                        onChange={(e)=>{
                                            setPassword(e.target.value);
                                            if (err){
                                                dispatch(resetPasswordFailure(false));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.tcErr} ${passwordErr ? Styles.tcErrActive : null}`}>{passwordErr || null}</div>
                                </div>

                                <div className={`${Styles.inputWrap} ${confirmationErr ? Styles.inputWrapWithErr : null}`}>
                                    <div className={`${Styles.inputTitle}`}>{t('Повторите пароль')}</div>
                                    <input
                                        className={`${Styles.tcInput}`}
                                        type="password"
                                        placeholder="••••••••"
                                        value={confirmation}
                                        onChange={(e)=>{
                                            setConfirmation(e.target.value);
                                            if (err){
                                                dispatch(resetPasswordFailure(false));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.tcErr} ${confirmationErr ? Styles.tcErrActive : null}`}>{confirmationErr || null}</div>
                                </div>
                            </div>

                            <div className={`${Styles.formHint}`}>
                                {t('Минимум 12 символов: строчные и заглавные буквы, цифры и спецсимволы.')}
                            </div>

                            {tokenErr ? (
                                <div className={`${Styles.linkErr}`}>
                                    <span>{tokenErr}</span>
                                    <span className={`${Styles.linkErrBtn}`} onClick={()=>{navigate('/forgot-password')}}>
                                        {t('Запросить новую ссылку')}
                                    </span>
                                </div>
                            ) : null}

                            <div className={`${Styles.tcErr} ${commonErr ? Styles.tcErrActive : null}`}>{commonErr}</div>

                            <div
                                className={`${Styles.tcBtn} ${started || !password.length || !confirmation.length ? Styles.tcBtnDsb : ''}`}
                                onClick={()=>{sendFormHandler()}}
                            >
                                {started ? t('Сохраняем…') : t('Сохранить пароль')}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ResetMain;
